module.exports = __webpack_public_path__ + "img/IDEA.0c571c60.png";